import OnIkiMatematik from "../pages/matematik/class12/OnIkiMatematik";


export const Matematik12 = [
  {
    path: "/matematik/12-sinif",
    element: <OnIkiMatematik activeDivProps={1} />
  }
];

